import React from 'react'
import Footer from './Footer'
import Navigation from './Navigation'

function Terms() {
  return (
    <>
    <Navigation/>
    <div className="container">
    <div className="entry-content wp-block-post-content has-global-padding is-layout-constrained wp-block-post-content-is-layout-constrained" bis_skin_checked="1">
        <p>Τελευταία ενημέρωση: 20 Φεβρουαρίου 2025</p>
        
        <p>Παρακαλούμε διαβάστε προσεκτικά αυτούς τους Όρους Χρήσης ("Όροι", "Όροι Χρήσης") πριν χρησιμοποιήσετε τον ιστότοπο https://grsocialge.site (η "Υπηρεσία") που διαχειρίζεται η https://grsocialge.site ("εμείς", "μας" ή "δικό μας").</p>
        
        <p>Η πρόσβασή σας και η χρήση της Υπηρεσίας εξαρτώνται από την αποδοχή και συμμόρφωση με αυτούς τους Όρους. Αυτοί οι Όροι ισχύουν για όλους τους επισκέπτες, χρήστες και οποιονδήποτε έχει πρόσβαση ή χρησιμοποιεί την Υπηρεσία.</p>
        
        <p>Με την πρόσβαση ή τη χρήση της Υπηρεσίας, συμφωνείτε ότι δεσμεύεστε από αυτούς τους Όρους. Εάν διαφωνείτε με οποιοδήποτε μέρος αυτών των όρων, δεν επιτρέπεται να χρησιμοποιήσετε την Υπηρεσία.</p>
        
        <p>Πριν συνεχίσετε τη λήψη της εφαρμογής, παρακαλούμε διαβάστε τους Όρους Παροχής Υπηρεσιών μας. Με τη λήψη και χρήση της εφαρμογής μας, συμφωνείτε με τα εξής:</p>
        
        <ul>
            <li>Έχετε διαβάσει πλήρως και κατανοήσει τους Όρους Παροχής Υπηρεσιών μας.</li>
            <li>Συμφωνείτε να χρησιμοποιείτε την υπηρεσία μας νόμιμα.</li>
            <li>Συναινείτε στην επεξεργασία των προσωπικών σας δεδομένων, όπως καθορίζεται στην πολιτική απορρήτου μας.</li>
        </ul>
        
        <p>Έχετε διαβάσει και συμφωνήσει με τους Κανόνες Υπεύθυνου Παιχνιδιού μας.</p>
        
        <h2 className="wp-block-heading">Βασικές Προϋποθέσεις</h2>
        
        <p>1.1. Αυτοί οι Όροι Παροχής Υπηρεσιών καθορίζουν τους κανόνες χρήσης των διαδραστικών υπηρεσιών ("Υπηρεσίες") που προσφέρει ο Πάροχος Υπηρεσιών μέσω της διαδικτυακής πλατφόρμας https://grsocialge.site ("Υπηρεσία").</p>
        
        <p>1.2. Οι υπηρεσίες που προσφέρει ο Πάροχος Υπηρεσιών περιλαμβάνουν την παροχή πρόσβασης σε μια πλατφόρμα παιχνιδιών που προορίζεται αποκλειστικά για ψυχαγωγία. Οι χρήστες μπορούν να αλληλεπιδρούν, να ανταλλάσσουν πληροφορίες και να συζητούν θέματα σχετικά με τα παιχνίδια.</p>
        
        <p>1.3. Στα προσφερόμενα παιχνίδια, οι χρήστες μπορούν να συμμετέχουν σε παιχνίδια στα οποία το αποτέλεσμα εξαρτάται από την ταχύτητα αντίδρασης, την επιδεξιότητα και την αντίληψή τους. Για να κερδίσει ένας παίκτης, πρέπει να συγκεντρώσει τους περισσότερους πόντους.</p>
        
        <p>1.4. Η χρήση των υπηρεσιών και η εγγραφή στην Υπηρεσία σημαίνει αποδοχή των όρων που περιγράφονται στο παρόν έγγραφο. Οι χρήστες που έχουν πρόσβαση στην Υπηρεσία χωρίς εγγραφή υποχρεούνται επίσης να συμμορφώνονται με αυτούς τους Όρους Χρήσης, όπως ορίζεται από την ηλεκτρονική νομοθεσία.</p>
        
        <p>1.5. Ο Πάροχος Υπηρεσιών διευκρινίζει ότι δεν συνάπτει ατομικές συμφωνίες με τους χρήστες της Υπηρεσίας. Όλοι οι χρήστες υποχρεούνται να συμμορφώνονται με αυτούς τους Όρους Χρήσης.</p>
        
        <p>1.6. Η πλήρης χρήση όλων των δυνατοτήτων των παιχνιδιών εξαρτάται από την τεχνική συμβατότητα της συσκευής του χρήστη.</p>
        
        <p>1.7. Ο Πάροχος Υπηρεσιών δεν φέρει ευθύνη για τυχόν μη διαθεσιμότητα της Υπηρεσίας λόγω παραγόντων εκτός του ελέγχου του ή λόγω απρόβλεπτων περιστάσεων.</p>
        
        <h2 className="wp-block-heading">Κανόνες Υπεύθυνου Παιχνιδιού</h2>
        
        <p>Ο κύριος στόχος της υπηρεσίας μας είναι να παρέχει ψυχαγωγία στους χρήστες και να επεκτείνει τις γνώσεις τους για τα παιχνίδια. Θέλουμε όλοι οι χρήστες να χρησιμοποιούν την Υπηρεσία μας για αυτόν τον σκοπό. Ωστόσο, είναι πιθανό κάποιοι χρήστες να αφιερώνουν υπερβολικό χρόνο. Αυτές οι περιπτώσεις είναι σπάνιες, αλλά μπορούν να αποφευχθούν ακολουθώντας τους παρακάτω βασικούς κανόνες:</p>
        
        <ul>
            <li>Παίξτε για διασκέδαση.</li>
            <li>Κατανοήστε ότι οι βαθμολογίες δεν έχουν πραγματική αξία και είναι μόνο για προσωπική ικανοποίηση.</li>
            <li>Αναζητήστε τη νίκη, αλλά αποφύγετε το αίσθημα της εκδίκησης.</li>
            <li>Αποφύγετε το παιχνίδι όταν αισθάνεστε λυπημένοι, κουρασμένοι ή απογοητευμένοι.</li>
        </ul>
        
        <h2 className="wp-block-heading">Επικοινωνία</h2>
        
        <p>Εάν έχετε οποιαδήποτε ερώτηση σχετικά με αυτούς τους Όρους, παρακαλούμε επικοινωνήστε μαζί μας.</p>
    </div>
</div>

    <Footer/>
    </>
  )
}

export default Terms